import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateReportSchemeState } from "../../Store";
import ReportItemEntityListRow from "../Entities/ReportItemEntityListRow";

export default function EmptySpace({ entity, children }) {
  const dispatch = useDispatch();
  const entityList = useSelector((state) => state.reportScheme.visibleReportItemEntityList);

  const deleteElement = () => {
    let newList = JSON.parse(JSON.stringify(entityList));

    newList.splice(entity.order - 1, 1);
    newList.forEach((entity, i) => {
      entity.order = i + 1;
    });
    dispatch(updateReportSchemeState({ visibleReportItemEntityList: newList }));
  };

  return (
    <>
      <div className="report-scheme-report-item-row">
        <ReportItemEntityListRow entity={entity} itemName="Boşluk" />
        {children && children}
      </div>

      {children && children}
    </>
  );
}
